import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-5 pb-5 container" }
const _hoisted_2 = { class: "header d-flex justify-content-between align-itens-center col" }
const _hoisted_3 = { class: "m-0" }
const _hoisted_4 = { class: "container-form mb-4" }
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "form-group mb-3 w-75" }
const _hoisted_8 = { for: "name" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = { class: "form-group mb-3 w-25" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "cnpj" }, "CNPJ", -1)
const _hoisted_12 = { class: "row mt-3" }
const _hoisted_13 = { class: "form-group mb-3 w-25" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "cep" }, "CEP", -1)
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = { class: "form-group mb-3 w-50" }
const _hoisted_17 = { for: "street" }
const _hoisted_18 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_19 = { class: "form-group mb-3 w-25" }
const _hoisted_20 = { for: "number" }
const _hoisted_21 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_22 = { class: "row mt-3" }
const _hoisted_23 = { class: "form-group m-0 w-25" }
const _hoisted_24 = { for: "district" }
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = { class: "form-group w-25" }
const _hoisted_27 = { for: "city" }
const _hoisted_28 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_29 = { class: "form-group w-25" }
const _hoisted_30 = { for: "state" }
const _hoisted_31 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_32 = { class: "form-group w-25" }
const _hoisted_33 = { for: "country" }
const _hoisted_34 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_35 = { class: "container-contact w-100" }
const _hoisted_36 = { class: "selected-contacts d-flex justify-content-between align-itens-center p-4" }
const _hoisted_37 = { class: "form mt-4" }
const _hoisted_38 = { class: "form-group w-25" }
const _hoisted_39 = { for: "typeContact" }
const _hoisted_40 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_41 = { class: "form-group w-25" }
const _hoisted_42 = { for: "nameContato" }
const _hoisted_43 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_44 = { class: "form-group w-25" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "E-mail", -1)
const _hoisted_46 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_47 = { class: "form-group w-25" }
const _hoisted_48 = { for: "phone" }
const _hoisted_49 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_ds_button = _resolveComponent("ds-button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.organizationId ? _ctx.$t('org.edit') : _ctx.$t('org.register')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('org.fields.name')), 1),
            _createVNode(_component_InputText, {
              id: "name",
              name: "name",
              type: "text",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.organization.name.$error ? 'p-invalid' : ''}`]),
              placeholder: "Ex: Empresa X",
              modelValue: _ctx.form.organization.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.organization.name) = $event)),
              required: ""
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.form.organization.name.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_InputMask, {
              modelValue: _ctx.form.organization.cnpj,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.organization.cnpj) = $event)),
              useGrouping: false,
              id: "cnpj",
              class: "d-block number-input",
              mask: "99.999.999/9999-99",
              name: "cnpj",
              placeholder: "00.000.000/0000-00",
              type: "text"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_InputMask, {
              id: "cep",
              name: "cep",
              type: "text",
              placeholder: "00000-000",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.organization.address.cep.$error ? 'p-invalid' : ''}`]),
              mask: "99999-999",
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getAddressData())),
              modelValue: _ctx.form.organization.address.cep,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.organization.address.cep) = $event)),
              required: ""
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.form.organization.address.cep.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('org.fields.street')), 1),
            _createVNode(_component_InputText, {
              id: "street",
              name: "street",
              type: "text",
              placeholder: "Ex: Rua X",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.organization.address.street.$error ? 'p-invalid' : ''}`]),
              modelValue: _ctx.form.organization.address.street,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.organization.address.street) = $event)),
              required: ""
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.form.organization.address.street.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_18, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('org.fields.number')), 1),
            _createVNode(_component_InputNumber, {
              id: "number",
              name: "number",
              type: "text",
              placeholder: "Ex: 55",
              class: _normalizeClass(["d-block number-input", `w-100 ${_ctx.v$.form.organization.address.number.$error ? 'p-invalid' : ''}`]),
              useGrouping: false,
              modelValue: _ctx.form.organization.address.number,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.organization.address.number) = $event)),
              required: ""
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.form.organization.address.number.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('org.fields.district')), 1),
            _createVNode(_component_InputText, {
              id: "district",
              name: "district",
              type: "text",
              placeholder: "Ex: Centro",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.organization.address.district.$error ? 'p-invalid' : ''}`]),
              modelValue: _ctx.form.organization.address.district,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.organization.address.district) = $event)),
              required: ""
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.form.organization.address.district.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_25, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('org.fields.city')), 1),
            _createVNode(_component_InputText, {
              id: "city",
              name: "city",
              type: "text",
              placeholder: "Ex: Fortaleza",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.organization.address.city.$error ? 'p-invalid' : ''}`]),
              modelValue: _ctx.form.organization.address.city,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.organization.address.city) = $event)),
              required: ""
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.form.organization.address.city.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_28, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('org.fields.state')), 1),
            _createVNode(_component_InputText, {
              id: "state",
              name: "state",
              type: "text",
              placeholder: "Ex: CE",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.organization.address.state.$error ? 'p-invalid' : ''}`]),
              modelValue: _ctx.form.organization.address.state,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.organization.address.state) = $event)),
              required: ""
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.form.organization.address.state.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('org.fields.country')), 1),
            _createVNode(_component_InputText, {
              id: "country",
              name: "country",
              type: "text",
              placeholder: "Ex: Brasil",
              class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.organization.address.country.$error ? 'p-invalid' : ''}`]),
              modelValue: _ctx.form.organization.address.country,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.organization.address.country) = $event)),
              required: ""
            }, null, 8, ["modelValue", "class"]),
            (_ctx.v$.form.organization.address.country.$error)
              ? (_openBlock(), _createElementBlock("small", _hoisted_34, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t('org.fields.lenContacts')) + ": " + _toDisplayString(_ctx.form.organization.contacts.length), 1),
            _createVNode(_component_ds_button, {
              class: "float-end",
              type: "tertiary",
              text: _ctx.$t('org.fields.addContact'),
              leftIcon: "add",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addNewContact()))
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", _hoisted_37, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.organization.contacts, (contato, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row mt-4",
                key: contato.id
              }, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('org.fields.type')), 1),
                  _createVNode(_component_Dropdown, {
                    id: "typeContact",
                    name: "typeContact",
                    type: "text",
                    class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.organization.contacts.$error ? 'p-invalid' : ''}`]),
                    options: _ctx.typeContact,
                    optionLabel: "name",
                    optionValue: "code",
                    placeholder: _ctx.$t('org.fields.selectType'),
                    modelValue: contato.typeContact,
                    "onUpdate:modelValue": ($event: any) => ((contato.typeContact) = $event),
                    disabled: _ctx.organizationId && index === 0 ? true : false
                  }, {
                    option: _withCtx(({ option }) => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(option.title_key)), 1)
                    ]),
                    _: 2
                  }, 1032, ["options", "placeholder", "modelValue", "onUpdate:modelValue", "disabled", "class"]),
                  (_ctx.v$.form.organization.contacts.$error)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_40, _toDisplayString(_ctx.v$.form.organization.contacts.$error), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('org.fields.nameContact')), 1),
                  _createVNode(_component_InputText, {
                    id: "nameContato",
                    name: "name",
                    type: "text",
                    class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.organization.contacts.$error ? 'p-invalid' : ''}`]),
                    placeholder: _ctx.$t('org.fields.contactName'),
                    modelValue: contato.name,
                    "onUpdate:modelValue": ($event: any) => ((contato.name) = $event),
                    disabled: _ctx.organizationId && index === 0 ? true : false
                  }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue", "disabled", "class"]),
                  (_ctx.v$.form.organization.contacts.$error)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_43, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createVNode(_component_InputText, {
                    id: "email",
                    name: "email",
                    type: "email",
                    class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.organization.contacts.$error ? 'p-invalid' : ''}`]),
                    placeholder: "example@email.com",
                    modelValue: contato.email,
                    "onUpdate:modelValue": ($event: any) => ((contato.email) = $event),
                    disabled: _ctx.organizationId && index === 0 ? true : false
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "class"]),
                  (_ctx.v$.form.organization.contacts.$error)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_46, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('org.fields.phone')), 1),
                  _createVNode(_component_InputMask, {
                    id: "phone",
                    name: "phone",
                    mask: "(99) 99999-9999",
                    type: "text",
                    class: _normalizeClass(["form-control", `w-100 ${_ctx.v$.form.organization.contacts.$error ? 'p-invalid' : ''}`]),
                    placeholder: "(00) 00000-0000",
                    modelValue: contato.phone,
                    "onUpdate:modelValue": ($event: any) => ((contato.phone) = $event),
                    disabled: _ctx.organizationId && index === 0 ? true : false
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "class"]),
                  (_ctx.v$.form.organization.contacts.$error)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_49, _toDisplayString(_ctx.$t('utils.mandatory')), 1))
                    : _createCommentVNode("", true)
                ]),
                (index !== 0)
                  ? (_openBlock(), _createBlock(_component_ds_button, {
                      key: 0,
                      type: "tertiary",
                      text: _ctx.$t('org.fields.deleteContact'),
                      class: "delete-contact mt-2 col-sm-2",
                      leftIcon: "delete",
                      onClick: ($event: any) => (_ctx.organizationId ? _ctx.deleteContactOrganization(contato.id): _ctx.deleteContact(index))
                    }, null, 8, ["text", "onClick"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_ds_button, {
          type: "secondary",
          text: _ctx.$t('utils.back'),
          class: "float-start me-3",
          onClick: _cache[11] || (_cache[11] = () => _ctx.$router.push({ name: 'Organizations' }))
        }, null, 8, ["text"]),
        _createVNode(_component_ds_button, {
          type: "primary",
          text: _ctx.$t('utils.save'),
          class: "float-start",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sendOrganization()))
        }, null, 8, ["text"])
      ])
    ])
  ]))
}